import { defineStore } from "pinia";

export const useChromeStore = defineStore("chrome", () => {
  const registeredModals = ref<string[]>([]);
  const visibleModals = ref<string[]>([]);

  return {
    blockUI: computed(() => visibleModals.value.length > 0),
    unblock: () => (visibleModals.value = []),
    notificationActive: computed(() => visibleModals.value.length),
    visibleModals,
    registeredModals,
    register: (id: string) => (registeredModals.value = [...registeredModals.value, id]),
    unregister: (id: string) => (registeredModals.value = registeredModals.value.filter((_id) => _id !== id)),
  };
});
